import React from "react";
//-Components
import { Container, Row, Col } from "react-bootstrap";
import Jumbo from "../components/Jumbo";
//-Images
import IOTImage from "../assets/img/serviceImages/IOT.svg";
import MobileDevImage from "../assets/img/serviceImages/Mobile.svg";
import WebDevImage from "../assets/img/serviceImages/Web.svg";
import DigitalMarketingImage from "../assets/img/serviceImages/DigitalMarketing.svg";
import GraphicDesignImage from "../assets/img/serviceImages/GraphicDesign.svg";
import TrainingImage from "../assets/img/serviceImages/Training.svg";

const pageName = "Services";
const message =
  "Futuristic software development services to address business needs efficiently.";

const ServicePage = () => {
  return (
    <div>
      <Jumbo pageName={pageName} message={message}></Jumbo>
      <Container className="main-section">
        <Row>
          <Col xs={12} md={4}>
            <img src={IOTImage} alt="internet of things" />
          </Col>
          <Col xs={12} md={8}>
            <p>
              <h1>IOT Products</h1>
              Leverage our IoT Services to drive towards success! The IoT
              services that we offer changes the entire story of IoT engagement
              in your business. Our IoT services let you connect and exchange
              data more efficiently. And we assure, once you implement our IoT
              services, you won’t leave us.
            </p>
            <br />
            <p>
              We deploy core technologies like{" "}
              <b>Java, Javascript, python and Node.js</b> that identify and
              validate your business case. You can quickly then connect your
              physical technologies with our advanced software to exchange data
              over the internet. So, ensure your business success by
              implementing IoT services from CURiGMA.
            </p>
          </Col>
        </Row>
        <hr />
      </Container>

      <Container className="main-section">
        <Row>
          <Col xs={12} md={8}>
            <p>
              <h1>Mobile Applications</h1>
              Align our mobile applications as a strategic partner for your
              business enhancement! Today’s dynamic era demands integrations of
              advanced mobile applications with the newest technologies to ease
              customer service. At the same time, aligning applications into a
              business eliminates inefficiencies and redundancies
            </p>
            <br />
            <p>
              <b>The latest framework that we implement:</b>
              <p></p>
              <li>React Native</li>
              <li>Google’s flutter</li>
              <li>Swift</li>
              <li>Ionic</li>
            </p>
            <p>
              That’s why we have come up with advanced mobile application
              services that will eliminate all hassles in your business.
            </p>
            <br />
            <p>
              <b>Our mobile application offers you:</b>
              <p></p>
              <li>End-to-end services</li>
              <li>Customer-centric operation</li>
              <li>Unified services delivery</li>
              <li>Apps for IOS and Android</li>
            </p>
          </Col>
          <Col xs={12} md={4}>
            <img src={MobileDevImage} alt="internet of things" />
          </Col>
        </Row>
        <hr />
      </Container>
      <Container className="main-section">
        <Row>
          <Col xs={12} md={4}>
            <img src={WebDevImage} alt="internet of things" />
          </Col>
          <Col xs={12} md={8}>
            <p>
              <h1>Web Applications</h1>
              <p>
                <b>Our semantic technology includes:</b>
                <p></p>
                <li>Python Django and flask</li>
                <li>Java</li>
                <li>Node js</li>
                <li>.NET</li>
              </p>
            </p>
            <br />
            <p>
              Boost your speed, agility, and efficiency! We bring you
              tailor-made Web application services that enhance your internal
              and external business operations. With an invincible web
              application, your business will touch the sky. And that’s not all
              yet! We offer you web app development services that include
              single-page apps, and progressive web apps. So, create your
              consumer-focused web portal by obtaining our web app services. We
              assure you to create a customer-centric platform to enhance your
              services.
            </p>
          </Col>
        </Row>
        <hr />
      </Container>
      <Container className="main-section">
        <Row>
          <Col xs={12} md={8}>
            <p>
              <h1>Digital Marketing</h1>
              Mark a strong presence online! Curigma offers you a complete
              digital marketing solution that helps you rule the online market.
              Advanced search engine optimization tactics along with
              result-driven social media marketing, your business will rule the
              game!
            </p>
            <br />
            <p>
              Our one-stop-shop for digital marketing includes content writing.
              We have professional writers with enormous experience who create
              content that will attract all audiences. They come up with unique
              marketing lines that help you get a better response. Further, our
              social media marketing helps you trend on social media platforms.
              So, what are you waiting for? Top the marketing game with digital
              marketing services from Curigma!
            </p>
          </Col>
          <Col xs={12} md={4}>
            <img src={DigitalMarketingImage} alt="internet of things" />
          </Col>
        </Row>
        <hr />
      </Container>
      <Container className="main-section">
        <Row>
          <Col xs={12} md={4}>
            <img src={GraphicDesignImage} alt="internet of things" />
          </Col>
          <Col xs={12} md={8}>
            <p>
              <h1>Graphic Design</h1>
              Bring life to your brand image! Curigma offers you graphic designs
              that will create an instant connection with your potential
              customers. We use advanced tools to create designs that are beyond
              words.
            </p>
            <br />
            <p>
              We deploy adobe professional for UI and UX. Further, we also
              integrate with illustrator and Photoshop to create a design that
              you want. So, whether it is a graphic design for your virtual
              platform or company logo, we never miss a chance to amaze you with
              our never-have-before graphic designs.
            </p>
          </Col>
        </Row>
        <hr />
      </Container>
      <Container className="main-section">
        <Row>
          <Col xs={12} md={8}>
            <p>
              <h1>Training</h1>
              Curigma aims to fuse the virtual world with the physical world.
              That is why we offer advanced training for IT industries. Our
              training subjects offer IT knowledge that will lead everyone to
              offer the highest standard of professionalism in IT.
            </p>
            <br />
            <p>
              We offer consulting training for IT industries to help them make
              their way to success. Our IT training also includes simulation
              based-training. This eases the whole process of learning
              information and technology.
            </p>
          </Col>
          <Col xs={12} md={4}>
            <img src={TrainingImage} alt="internet of things" />
          </Col>
        </Row>
        <hr />
      </Container>
    </div>
  );
};

export default ServicePage;
